// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { gql } from 'graphql-tag'
import React from 'react'
import { Mutation } from 'react-apollo'
import type { Location, RouterHistory } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import Header, { HEADER_TYPE_SUBPAGE } from '../header/Header'
import css from './taskListCreatePage.css'

import Button from '@mui/material/Button/Button'
import moment from 'moment'
import Container from '../../common/container/Container'
import DateField from '../../common/dateField/DateField'
import Select, { MultiSelect } from '../../common/select/Select'
import Textarea from '../../common/textarea/Textarea'
import { i18n } from '../index'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import { ASSIGNMENTS_QUERY, getAssignmentSubjectOptions } from './data'
const CREATE_ASSIGNMENT = gql`
  mutation CreateAssignment($stationId: ID!, $assignment: CreateAssignmentType!) {
    createAssignment(stationId: $stationId, assignment: $assignment) {
      __typename
      id
      subject
      description
      assignee {
        id
        name
      }
      assignees {
        id
        name
      }
      deadline
      status
      comment
      doneAt
    }
  }
`
type Props = {
  history: RouterHistory
  location: Location
  activeStation: Station
}
type FormData = {
  subject: string
  description: string
  userId: string
  deadline: string
}
type State = {
  formData: FormData
  refetchParameters: {
    stationId?: string
    status?: string
    subject?: string
    fromDate?: string
    toDate?: string
  } | null
}
type Option = {
  label: string
  value: string | null | undefined
}

const usersToOptions = (users: Array<any>): Array<Option> =>
  users.map((user) => ({
    label: user.name,
    value: user.id,
  }))

@withActiveStation
class TaskListCreatePage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      formData: {
        subject: props.location.state ? props.location.state.subject : '',
        description: '',
        userId: '',
        userIds: [],
        deadline: moment().format('YYYY-MM-DD'),
      },
      ui: {
        usersSelected: [],
      },
      refetchParameters:
        props.location.state && props.location.state.refetchParameters ? props.location.state.refetchParameters : null,
    }
  }

  validate = () => {
    const { formData } = this.state
    // TODO: Proper validations
    return !!formData.subject && !!formData.description && !!formData.userIds && !!formData.userIds.length
  }
  onSubmit = (event: React.SyntheticEvent, mutation: (...args: Array<any>) => any) => {
    if (this.validate()) {
      const { activeStation } = this.props
      mutation({
        variables: {
          stationId: activeStation.id,
          assignment: { ...this.state.formData },
        },
      })
    }

    event.preventDefault()
  }
  onCompleted = () => {
    this.props.history.goBack()
  }
  setFieldValue = (field: string, value: any) => {
    this.setState({
      formData: { ...this.state.formData, [field]: value },
    })
  }
  getFieldValue = (field: string) => {
    return this.state.formData[field]
  }

  setUserIds = (options: Array<Option>) => {
    const userIds = options.map((option) => option.value)
    this.setState({
      formData: { ...this.state.formData, userIds: userIds },
    })
    this.setState({
      ui: { usersSelected: [...options] },
    })
  }

  render() {
    const { activeStation } = this.props
    const users = activeStation.users || []
    const { refetchParameters } = this.state
    const refetchVariables = refetchParameters
      ? refetchParameters
      : {
          stationId: activeStation.id,
          status: 'InProgress',
        }
    return (
      <div className={css.component}>
        <Header title={i18n.t('taskList.createPage.header')} headerType={HEADER_TYPE_SUBPAGE} showLogo={false} />
        <Container>
          <Mutation
            mutation={CREATE_ASSIGNMENT}
            onCompleted={this.onCompleted}
            refetchQueries={() => [
              {
                query: ASSIGNMENTS_QUERY,
                variables: refetchVariables,
              },
            ]}
          >
            {(mutation) => (
              <div className={css.component}>
                <form onSubmit={(event) => this.onSubmit(event, mutation)}>
                  <Select
                    className={css.subjectSelect}
                    label={i18n.t('taskList.createPage.subjectLabel')}
                    placeholder={i18n.t('taskList.createPage.subjectPlaceholder')}
                    value={this.getFieldValue('subject')}
                    onChange={(option) => this.setFieldValue('subject', option.value)}
                    options={getAssignmentSubjectOptions()}
                  />
                  <Textarea
                    label={i18n.t('taskList.createPage.descriptionLabel')}
                    placeholder={i18n.t('taskList.createPage.descriptionPlaceholder')}
                    value={this.getFieldValue('description')}
                    onChange={(event) => this.setFieldValue('description', event.target.value)}
                  />
                  <div className={css.row}>
                    <MultiSelect
                      className={css.userSelect}
                      label={i18n.t('taskList.createPage.assigneeLabel')}
                      placeholder={i18n.t('taskList.createPage.assigneePlaceholder')}
                      value={this.state.ui.usersSelected}
                      onChange={(options) => this.setUserIds(options)}
                      options={usersToOptions(users)}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      isMulti
                    />
                    <DateField
                      label={i18n.t('taskList.createPage.deadlineLabel')}
                      value={this.getFieldValue('deadline')}
                      onChange={(value) => this.setFieldValue('deadline', value)}
                      modifiers={{
                        disabled: {
                          before: new Date(),
                        },
                      }}
                      labelOnTop
                    />
                  </div>
                  <div className={css.actions}>
                    <Button type='input' variant='contained' color='primary'>
                      {i18n.t('buttons.save')}
                    </Button>
                  </div>
                </form>
              </div>
            )}
          </Mutation>
        </Container>
      </div>
    )
  }
}

export default withRouter(TaskListCreatePage)
